
import type SliderType from "react-slick";
import SliderOrig from "react-slick";
import { useRef } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
const Slider = SliderOrig as unknown as React.ComponentType<any>;

function ProductSlider(props: any) {

	const { products } = props
	const { t } = useTranslation();

	const sliderRef = useRef<SliderType | null>(null);

	const settingSlider = {
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: false,
		fade: false,
		adaptiveHeight: true,
		infinite: false,
		speed: 400,
		swipe: true,
		draggable: true,
		cssEase: "cubic-bezier(0.77, 0, 0.18, 1)",
		beforeChange: (current: number, next: number) => {
			sliderRef.current?.slickGoTo(next);
		},
	}

	return (
		<>
			
			<div className="slider">
				<Slider ref={sliderRef} {...settingSlider}>
					{products.map((item: any) => (
						<div className="slider-container" key={item.id}>
							<div className="content">
								<p className="title">{item.title}</p>
								{/* <div className="context" dangerouslySetInnerHTML={{ __html: JSON.parse(item.introduction)[0].description}} style={{ height: 'max-content' }}></div> */}
								{JSON.parse(item.introduction) && JSON.parse(item.introduction)?.map((item: any) => <div key={item.id} className="context" style={{ height: 'max-content', fontSize: '14px' }} dangerouslySetInnerHTML={{ __html: item.description?.en ? '' : item.description }} />)}
								{/* <div className="context" style={{ height: 'max-content', fontSize: '14px' }}>{item.subtitle}</div> */}
								{/* <a className='btn-link1' href={item.href}>{item.subtitle}</a> */}
								{JSON.parse(item.description)[0] ?
									<Link className='btn-link1' to={`/numerologist-products/${item.id}`}>{t('viewFreeReading')}</Link>
									:
									<div className='btn-link1 btn-disabled'>{t('CommingSoon')}</div>
								}
							</div>
							{item.image_url && (
								<div className="img-box">
									<img src={item.image_url} loading="lazy" alt="img" />
								</div>
							)}
						</div>
					))}
				</Slider>
			</div>
		</>
	);
}

export default ProductSlider;